var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-tree content-block"},[_c('fm-title',{attrs:{"title-text":"机构 \\ 职务"}}),_c('div',{staticClass:"org-tree-c"},[_c('fm-tree',{directives:[{name:"loadingx",rawName:"v-loadingx",value:(_vm.loading),expression:"loading"}],attrs:{"nodes":_vm.showNodes,"node-render":_vm.nodeRender,"search":"","is-selected":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }